import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import classnames from 'classnames';
import chatStorage from '../chatStorage';
import TextInput from '../../../components/forms/TextInput';
import EditableText from '../../../components/forms/EditableText';
import StandardButton from '../../../components/buttons/Base/StandardButton';

class ContactsList extends Component {
  state = {
    opened: false,
  }

  toggleOpened = () => this.setState((state) => ({ opened: !state.opened }))

  render() {
    const { t } = this.props;
    const { opened } = this.state;
    const registerDate = (chatStorage.currentChat.created_at instanceof Date) ? chatStorage.currentChat.created_at.toLocaleDateString() : (new Date(chatStorage.currentChat.created_at)).toLocaleDateString();
    const lastseenDate = (chatStorage.currentChat.updated_at instanceof Date) ? chatStorage.currentChat.updated_at.toLocaleDateString() : (new Date(chatStorage.currentChat.updated_at)).toLocaleDateString();
    const { account, contacts } = chatStorage.currentChat;
    const cn = classnames({
      contactsContainer: true,
      changedContainer: chatStorage.changed,
    });
    return (
      <div className={cn}>
        <div className="flex justify-content-between align-items-center">
          <h5>
            {t('Names')}
            {' '}
            /
            {' '}
            {contacts.id}
          </h5>
          {contacts.perfectum_id && (
            <a
              href={`https://rehabilitolog.perfectum.cloud/admin/clients/client/${contacts.perfectum_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              CRM
            </a>
          )}
        </div>
        <ul>
          <li>
            {t('users.alias')}
            :
            {' '}
            {account.name || 'Unknown'}
          </li>
          <li>
            <EditableText
              opened={opened}
              value={account.first_name}
              label={t('users.name')}
              placeholder={t('users.name')}
              id="first_name"
              onInput={chatStorage.changeCurrentChatAccountField}
              emptyValueText="---"
              onSave={chatStorage.saveCurrentChatAccountField}
            />
          </li>
          <li>
            <EditableText
              opened={opened}
              value={account.soname}
              label={t('users.soname')}
              placeholder={t('users.soname')}
              id="soname"
              onInput={chatStorage.changeCurrentChatAccountField}
              emptyValueText="---"
              onSave={chatStorage.saveCurrentChatAccountField}
            />
          </li>
          <li>
            <EditableText
              opened={opened}
              value={account.last_name}
              label={t('users.surname')}
              placeholder={t('users.surname')}
              id="last_name"
              onInput={chatStorage.changeCurrentChatAccountField}
              emptyValueText="---"
              onSave={chatStorage.saveCurrentChatAccountField}
            />
          </li>
          <li>
            {t('users.registerDate')}
            :
            {' '}
            {registerDate}
          </li>
          <li>
            {t('users.lastSeen')}
            :
            {' '}
            {lastseenDate}
          </li>
        </ul>
        <h5>{t('Contacts')}</h5>
        <ul>
          <li>
            <EditableText
              opened={opened}
              value={contacts.value}
              label={t('Phone')}
              placeholder={t('Phone')}
              id="mainPhone"
              onInput={contacts.changeValue}
              emptyValueText="---"
              onSave={(field, value) => chatStorage.saveCurrentChatMainContact(field, value, 1)}
              debug
            />
          </li>
          <li>
            E-mail: -
          </li>
          {/* <li> */}
          {/*  {t('users.channel')} */}
          {/*  : -*/}
          {/* </li> */}
        </ul>
        <h5>{t('Comments')}</h5>
        <ul>
          <li>
            {t('users.comments')}
            : -
          </li>
        </ul>
        {!chatStorage.changed && (
        <StandardButton onClick={this.toggleOpened} id="openEditor">
          {opened ? t('Close') : t('Edit')}
        </StandardButton>
        )}
      </div>
    );
  }
}

ContactsList.propTypes = {};

export default translate(observer(ContactsList));
